import styled from 'styled-components';

interface FormTitlePropsType {
  title: string;
}

const FormTitle = ({ title }: FormTitlePropsType) => {
  return <Title>{title}</Title>;
};

export default FormTitle;

// ======================= styled-components =======================

const Title = styled.p`
  white-space: nowrap;
  font-size: 16px;
  line-height: 24px;
  text-align: start;

  @media (min-width: 640px) {
    font-size: 20px;
    line-height: 30px;
  }
`;
